import { useQuery } from '@tanstack/react-query';
import { bankApplicationsApi } from '@modules/opportunities/entities/bankApplication/api';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';

const useGetDigitalBankApplications = (opportunityId: string) => {
  const { isFeatureActive } = useFeatureFlags();
  const isFeatureFlagOn = isFeatureActive('opportunities.esignature');
  const { data, refetch, isLoading } = useQuery({
    queryKey: ['bankDigitalDocs', opportunityId],
    queryFn: () => bankApplicationsApi.getDigitalBankApplications(
      { opportunityExternalId: opportunityId },
      isFeatureFlagOn ? 'digital-bank-applications-documents' : 'digital-bank-applications'
    ),
    retry: false,
  });

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useGetDigitalBankApplications;
